<template>
	<div id="showEditSlides">
		<div class="header">
			<input type="text"
				ref="titleInput"
				class="showTitle"
				:class="{ showTitlePreview: isInPreview }"
				:readonly="isInPreview"
				v-model="show.title"
				v-on:keyup.enter="onTitleChanged" 
				v-on:blur="onTitleFocusLost"
				>
			<div v-if="isInPreview" class="previewNav">
				<IconBase class="icon"
						  iconName="back"
						  width="48"
						  height="48"
						  viewBox="13 0 75 80"
						  @onIconClicked="backStep">
					<IconBack/>
				</IconBase>

				<IconBase class="icon"
						  iconName="next"
						  width="48"
						  height="48"
						  viewBox="13 0 75 80"
						  @onIconClicked="nextStep">
					<IconNext/>
				</IconBase>
			</div>
			<div class="controls">
				<div v-if="show.is_Public" v-on:click="toggleIsPublic"
					 class="control">
					<IconBase class="icon"
							  iconName="öffentlich"
							  width="63"
							  height="38"
							  viewBox="-5 -7 63 45">
						<IconPublic/>
					</IconBase>
					<span>öffentlich</span>
				</div>
				<div v-if="!show.is_Public" v-on:click="toggleIsPublic"
					 class="control">
					<IconBase class="icon"
							  iconName="intern"
							  width="63"
							  height="38"
							  viewBox="-5 -1 63 45">
						<IconPrivate/>
					</IconBase>
					<span>intern</span>
				</div>
			</div>
		</div>
		<div class="content-wrapper">
			<div class="content">
				<div class="model-disable"></div>
				<div class="wall-disable"></div>
				<div class="step">
					<div class="slide first">
						<div class="spacer">

						</div>
						<div class="item-wrapper">
							<div class="item model">
								<p>Modell</p>
							</div>
						</div>
						<div class="item-wrapper">
							<div class="item wall">
								<p>Wand</p>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!isInPreview" class="add-step"
					 v-on:click.stop.prevent="addStep(0)">
					<div class="add-wrapper">
						<ShowEditAddStep/>
					</div>
				</div>
				<div class="step"
					 v-bind:class="{ stepInPreview: isInPreview, 'currentStep': currentStepIndex === index}"
					 v-for="(step, index) in show.steps"
					 v-bind:key="index"
					 v-on:click="thisStep(index)">
					<div class="slide"
						 v-bind:draggable="!isInPreview ? true : false"
						 @dragstart="dragSlideStart(index, $event)"
						 @drop="dragSlideFinish(index, $event)"
						 @dragover.prevent
						 @dragleave="dragLeave"
						 v-bind:id="step.id"
						 v-bind:class="{'slide-in': newStepId === step.id, 'noHover': isInPreview}"

					>
						<div class="slide-head">
							<span class="number">{{index + 1}}</span>
							<ShowEditDelteStep v-bind:showDelete="show"
											   v-bind:step="step"
											   @reloadShow="reloadShow"
											   v-if="!isInPreview"
							/>
						</div>
						<div class="item-wrapper"
							 @drop="dragFinishItem('model', $event)"
							 @dragenter="dragEnter('model', $event)"
							 @dragleave="dragLeave($event)"
							 v-bind:stepId="step.id"
							 type='model'>

							<ShowEditDeleteSlide v-bind:deleteStep="step"
												 v-bind:showDelete="step.model_slide"
												 deleteType='model'
												 v-if="!isInPreview"
												 @reloadShow="reloadSlide"
							/>

							<ShowEditItem v-bind:step="step"
										  v-bind:type="'model'"></ShowEditItem>
						</div>
						<div class="item-wrapper"
							 @drop="dragFinishItem('wall', $event)"
							 @dragenter="dragEnter('wall', $event)"
							 @dragleave="dragLeave($event)"
							 v-bind:stepId="step.id"
							 type='wall'>

							<ShowEditDeleteSlide v-bind:deleteStep="step"
												 v-bind:showDelete="step.wall_slide"
												 deleteType='wall'
												 v-if="!isInPreview"
												 @reloadShow="reloadSlide"
							/>

							<ShowEditItem v-bind:step="step"
										  v-bind:type="'wall'"></ShowEditItem>

						</div>
						<div class="text"
							:class="{ noHover: isInPreview }"
							 v-on:click.stop.prevent="showText(step, index)">
							<IconBase class="icon notesActive"
									  :class="{ 'icon notesInactive': !hasText(step), 'noHover':isInPreview }"
									  iconName="notiz"
									  width="33"
									  height="33"
							>
								<IconNotiz/>
							</IconBase>
						</div>
					</div>
					<div v-if="!isInPreview" class="add-step"
						 v-on:click.stop.prevent="addStep(index + 1)">
						<div class="add-wrapper">
							<ShowEditAddStep/>
						</div>
					</div>
				</div>
				<div v-if="!isInPreview" class="slide add"
					 v-on:click="addStep(false)">
					<div class="spacer"></div>
					<div class="item-wrapper">
						<div class="item add">
							<ShowEditAddStep v-bind:large="true"/>
						</div>
					</div>

					<div class="item-wrapper">
						<div class="item"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Step from '@/services/Step';
	import Show from '@/services/Show';
	import ContentLoader from '@/services/ContentLoader';
	import ShowEditAddStep from './ShowEditAddStep';
	import ShowEditDelteStep from './ShowEditDelteStep';
	import ShowEditDeleteSlide from './ShowEditDeleteSlide';
	import ShowEditItem from './ShowEditItem';
	import IconBase from '@/components/icons/IconBase.vue';
	import IconPublic from '@/components/icons/IconPublic.vue';
	import IconPrivate from '@/components/icons/IconPrivate.vue';
	import IconNext from '@/components/icons/IconNext.vue';
	import IconBack from '@/components/icons/IconBack.vue';
	import IconNotiz from '@/components/icons/IconNotiz.vue';


	export default {
		name: "ShowEditSlides",
		components: {
			ShowEditAddStep,
			ShowEditDelteStep,
			ShowEditDeleteSlide,
			ShowEditItem,
			IconPublic,
			IconPrivate,
			IconBase,
			IconNext,
			IconBack,
			IconNotiz
		},
		props: [
			"show",
			"isInPreview",
			"currentStepIndex",
		],
		methods: {
			onTitleChanged() {
				this.$refs.titleInput.blur();
			},
			onTitleFocusLost() {
				this.updateShowOnServer();
			},
			async updateShowOnServer() {
				if(this.$refs.titleInput.value != this.showTitleOnServer) {
					await Show.put(this.show);
					this.showTitleOnServer = this.show.title;
				}
			},
			hasText(step) {
				if(step.text) return true;
				else return false;
			},
			async addStep(index) {
				if (index === false) {
					index = this.show.steps.length + 1;
				}
				let newStep = await Step.create({show: this.show.id});
				this.newStepId = newStep.id;

				await this.rearangeSteps(index, newStep.id, newStep);

				setTimeout(function () {
					this.reloadShow();
				}.bind(this), 200);
			},
			showText(step, index) {
				let param = {"step":step, "index":index};
				this.$emit('showText', param);
			},
			async toggleIsPublic() {
				this.show.is_Public = !this.show.is_Public;
				await Show.put(this.show);

			},
			async reloadShow() {
				console.log('>>>> reload');
				let slideIn = document.querySelectorAll('.slide-in');
				this.newStepId = false;
				for (let i = 0; i < slideIn.length; i++) {
					slideIn[i].classList.remove('slide-in')
				}

				this.$emit('reloadShow');
			},
			async reloadSlide() {
				this.$emit('reloadShow');
			},
			async rearangeSteps(targetIndex, id, newStep) {
				let currentStepsWithoutTarget = this.show.steps.filter(step =>
					step.id !== id).map(function (step) {
					return step.id;
				});

				let rearangedSteps = [];
				currentStepsWithoutTarget.splice(targetIndex, 0, id);
				for (id in currentStepsWithoutTarget) {
					let step = this.show.steps.find(step => step.id === currentStepsWithoutTarget[id]);
					if (!step) {
						step = newStep;
					}
					rearangedSteps.push(step);
				}

				this.show.steps = rearangedSteps;
				this.show.step_order = JSON.stringify(currentStepsWithoutTarget);

				await Show.put(this.show);
				this.$emit('reloadShow');
			},
			slideInStep(step) {
				step.className += ' slide-in';

				setTimeout(function () {
					step.className = step.className.replace('slide-in', '');
				}, 500);
			},
			dragSlideStart(index, event) {
				event.dataTransfer.setData('step_id', event.target.id);
				event.dataTransfer.dropEffect = 'move';
				this.dragging = index;
			},
			dragSlideFinish(to, event) {

				let stepId = parseInt(event.dataTransfer.getData('step_id'));
				if (!Number.isNaN(stepId)) {
					this.slideInStep(event.currentTarget);
					this.rearangeSteps(to, stepId);
				}
			},
			dragLeave(event) {
				event.target.classList.remove('drag-right');
			},
			dragEnter(type, event) {
				let itemList = document.querySelectorAll('.item');

				for (let i = 0; i < itemList.length; ++i) {
					itemList[i].classList.remove('drag-right');
				}

				event.target.closest('.item-wrapper').querySelector('.item:not(.drop-disabled)').classList.add('drag-right');
			},
			async dragFinishItem(type, event) {
				let slideInfo = JSON.parse(event.dataTransfer.getData('slide_info'));
				if (slideInfo.type !== type) {
					return;
				}

				let itemWrapper = event.target.closest('.item-wrapper');
				itemWrapper.querySelector('.item').classList.remove('drag-right');
				let stepId = parseInt(itemWrapper.getAttribute('stepid'));
				let slide = await ContentLoader.getSlide(type, slideInfo.id);
				let step = await Step.get(stepId);

				if (type === 'model') {
					step.model_slide = slide;
				} else {
					step.wall_slide = slide;
				}

				await Step.put(step);
				setTimeout(function () {
					this.reloadShow();
				}.bind(this), 200);
			},
			backStep() {
				this.$emit('backStep');
			},
			nextStep() {
				this.$emit('nextStep');
			},
			thisStep(index) {
				if(this.isInPreview) {
					this.$emit('thisStep', index);
				}
			},
		},
		data() {
			return {
				strapiUrl: process.env.VUE_APP_BASE_URL,
				dragging: false,
				newStepId: false,
				showTitleOnServer: this.show.title
			}
		}
	}
</script>

<style scoped>
	#showEditSlides {
		position: relative;
		padding-bottom: 30px;
		max-width: 100%;
		display: flex;
		flex-direction: column;
	}

	input {
		margin-top: 18px;
		padding-left: 20px;
		width: 50%;
		min-width: 500px;
		border: none;
	}

	input:focus {
		border: 0;
	}

	.showTitle {
		font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
		font-weight: bold;
		font-size: 25px;
		margin-bottom: 17px;
	}
	
	.showTitlePreview:hover {
		cursor: default;
	}
	
	.showTitlePreview:focus {
		border: 0;
		outline: 0;
	}

	.header {
		width: 100%;
		display: flex;
		height: 60px;
		border: 1px solid black;
		border-top: none;
		justify-content: space-between;
		align-items: center;
		padding-left: 0px; /*20px;*/
	}

	.controls {
		height: 100%;
		display: flex;
	}

	.control {
		display: flex;
		flex-direction: column;
		align-items: center;
		border-left: 1px solid black;
		padding: 5px 10px 0px 10px;
		font-size: 36px;
	}

	.control span {
		font-size: 9px;
	}

	.content-wrapper {
		width: 100%;
		overflow-x: auto;
		display: flex;
		align-self: flex-start;
	}

	.content {
		display: flex;
		padding-bottom: 11px;
		position: relative;
	}

	.show-diable {
		display: block;
	}

	.model-disable {
		bottom: 194px;
	}

	.wall-disable {
		bottom: 80px;
	}

	.step {
		display: flex;
		position: relative;
	}

	@-webkit-keyframes slide {
		100% {
			width: 0;
		}
	}

	@keyframes slide {
		100% {
			width: 163px;
		}
	}

	body .slide-in {
		width: 0;
		animation: slide 400ms forwards;
	}

	.slide {
		border: 1px solid black;
		border-top: none;
		width: 163px;
		position: relative;
	}

	.slide.add {
		border: none;
	}

	.slide:hover .slide-head {
		background-color: black;
		color: white;
	}

	.slide:hover {
		stroke: white;
		cursor: grab;
	}

	.slide:active {
		cursor: grabbing;
	}

	.slide-head {
		display: flex;
		justify-content: space-between;
		width: 100%;
		padding: 5px 2px 0px 5px;
		cursor: grab;
	}

	.add-step {
		width: 15px;
		background-color: white;
		color: white;
		font-size: 40px;
		text-align: center;
		padding: 157px 0px 0px 8px;
		position: relative;
	}

	.add-wrapper {
		display: none;
		height: 100%;
		background-color: black;
		width: 60px;
		cursor: pointer;
		position: absolute;
		top: 0;
		z-index: 9;
		left: -30px;
		opacity: 0.97;
		align-items: center;
		justify-content: space-around;
		border: 3px solid white;
	}

	.add-step:hover .add-wrapper {
		display: block;
	}

	.add:hover {
		background-color: white;
	}

	.first:hover {
		background-color: white;
		color: black;
	}

	.spacer {
		height: 26px;
	}

	.item-wrapper {
		background-color: #F2F2F2;
		margin-bottom: 25px;
		height: 90px;
		width: 161px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.item.drag-right {
		background-size: cover;
		opacity: 0.1;
	}

	.item.drop-disable {
		opacity: 0.3;
		background-color: black;
	}

	.item {
		background-position: center;
		background-size: contain;
		height: 90px;
		width: 161px;
		display: flex;
		align-items: center;
		justify-content: center;
		transform: scale(1);
	}

	.item.add {
		background-color: #F2F2F2;
		color: black;
		font-size: 45px;
		text-align: center;
	}

	.item.add.addBtnStep {
		background-color: #F2F2F2;
		color: black;
	}

	.item p {
		width: 70%;
	}

	.text {
		width: 35px;
		height: 35px;
		overflow: hidden;
		margin: auto;
		font-size: 15px;
		margin-bottom: 14px;
	}

	.text:hover {
		cursor: pointer;
	}

	.text svg {
		stroke: black;
	}

	.text svg:hover {
		stroke: white;
	}

	.noHover{
		pointer-events: none;
	}
	
	.notesActive g {
		stroke: black;
	}
	.notesActive:hover g {
		stroke: white;
	}
	.notesInactive g {
		stroke: #cdcdcd;
		fill: #cdcdcd;
	}
	.notesInactive:hover g {
		stroke: white;
	}

	.previewNav {
		width: 130px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.stepInPreview {
		margin-left: 20px;
	}

	.stepInPreview:hover {
		cursor: pointer;
	}
	.currentStep {
		border: 5px solid black;
	}

	.model,
	.wall {
		font-size: 23px;
	}
</style>